var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-grow justify-center items-center rounded-lg bg-white"},[_c('div',{staticClass:"flex flex-col justify-center items-center gap-2 my-20"},[_c('img',{staticClass:"w-36",attrs:{"src":require("../assets/icons/icon-water-advanture.png"),"alt":""}}),_c('p',{staticClass:"text-xl font-semibold"},[_vm._v("Select Destination")])])])
}]

export { render, staticRenderFns }